import HouseholdInfo from './HouseholdInfoView'

export default HouseholdInfo
